import { apiRequest } from "../api/apiClient";

const ROUTE_PREFIX = "/validation";

export const checkEmailExists = async (email: string) => {
  try {
    const { data, error } = await apiRequest(
      "post",
      `${ROUTE_PREFIX}/check_email`,
      { email }
    );
    if (error) {
      console.error("Email check failed:", error);
      return null;
    }
    return data;
  } catch {
    console.error("Email check failed");
    return null;
  }
};
